import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Info, ExternalLink } from "lucide-react";
import { useLang } from "@/lib/i18n";

// Micro-badge attached to every official field. Opens a popover with the exact
// government agency, service, ArcGIS REST endpoint and retrieval time.
export const SourceBadge = ({ agency, service, endpoint, retrievedAt }) => {
  const { t } = useLang();
  if (!agency) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          data-testid="source-badge"
          className="inline-flex items-center gap-1 rounded-full border border-border bg-secondary/70 px-2 py-0.5 text-[10px] font-medium uppercase tracking-[0.12em] text-muted-foreground transition-colors hover:border-primary/40 hover:text-primary"
        >
          <Info className="h-3 w-3" />
          <span data-testid="source-agency-label">{agency}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent
        data-testid="source-provenance-popover"
        align="start"
        className="w-80 border-border"
      >
        <div className="space-y-2">
          <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-accent">{t("source.official")}</p>
          <p className="font-serif text-base leading-snug text-foreground">{agency}</p>
          {service && <p className="text-sm text-muted-foreground">{service}</p>}
          {endpoint && (
            <a
              data-testid="source-endpoint-link"
              href={`${endpoint}?f=json`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("source.opensRest")}
              className="flex items-start gap-1.5 break-all rounded-md bg-secondary/70 p-2 font-mono text-xs text-primary underline-offset-2 hover:underline"
            >
              <ExternalLink className="mt-0.5 h-3 w-3 shrink-0" />
              {endpoint}
            </a>
          )}
          {retrievedAt && (
            <p className="font-mono text-[10px] text-muted-foreground">{t("source.retrieved", { x: retrievedAt })}</p>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};
